import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import DisplaySettings from "./DisplaySettings";
const SubmissionDocumentsTab: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    return <>
        <SettingsCol >
            <SettingsLabel text={"TRVB_DISPLAY_SETTINGS_HEADER"} labelPosition={'floating'} lines={'none'} />
            <DisplaySettings systemId={systemId} />
        </SettingsCol>
    </>;
};

export default SubmissionDocumentsTab;
